import { cn } from '../helpers/index.js'

export interface SpinnerProps {
  className?: string
}

// eslint-disable-next-line no-unused-vars
const Spinner = (props: SpinnerProps) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      width="1rem"
      className={cn('animate-spin', props.className)}
    >
      <path
        d="M1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Spinner
